let getIdTokenClaimsGlobal = null;
let loginWithRedirectGlobal = null;

export const setLoginWithRedirect = (loginWithRedirectFn) => {
  loginWithRedirectGlobal = loginWithRedirectFn;
};

export const setGetIdTokenClaims = (getIdTokenClaimsFn) => {
  getIdTokenClaimsGlobal = getIdTokenClaimsFn;
};

export const getAuth0IdToken = async () => {
  if (!getIdTokenClaimsGlobal) {
    console.log("Auth0 'getIdTokenClaims' function not set.");
    return null;
  }
  try {
    const idTokenClaims = await getIdTokenClaimsGlobal();
    return idTokenClaims.__raw;
  } catch (error) {
    console.log("Error getting Auth0 ID token claims:", error);
    return null;
  }

  // const tempOktaToken =
  //   "eyJraWQiOiJsbzlyZmRmWmtWQm5wQklLN1BEN0RhVml2SXZULUp4eG00RFZmQ0t0S3RjIiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIwMHVoNzhpNzU4V0xQeExkZTJwNyIsIm5hbWUiOiJTaWRodSwgSGVybWFuIFtFTVIvRU5UL0lUL01PSEFdIiwiZW1haWwiOiJoZXJtYW4uc2lkaHVAZW1lcnNvbi5jb20iLCJ2ZXIiOjEsImlzcyI6Imh0dHBzOi8vZW1lcnNvbi5va3RhLmNvbS9vYXV0aDIvZGVmYXVsdCIsImF1ZCI6IjBvYWZkNnBvYzQxZGdFaXBBMnA3IiwiaWF0IjoxNzUxNTI0MDgzLCJleHAiOjE3NTE1Mjc2ODMsImp0aSI6IklELllxUmFJNjliX0poVTVCT25xZzFtbmdRTnJiaGQtbmJDZFlkczFCM0taSnMiLCJhbXIiOlsicHdkIl0sImlkcCI6IkRTU08iLCJub25jZSI6InN4TDdPa3dZZXN4MnRFcWFjQ3U4cXFGRTZ3ZFNkVnZEMDFTY3NEQ0l4ZW9sd2pwcjZpbE1VUGIxQkFHYlE1UWoiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJoZXJtYW4uc2lkaHVAZW1lcnNvbi5jb20iLCJnaXZlbl9uYW1lIjoiSGVybWFuIiwiZmFtaWx5X25hbWUiOiJTaWRodSIsImF1dGhfdGltZSI6MTc1MTUyNDA3MiwiYXRfaGFzaCI6IlI3QndQWThFQTgyejdhanNLdjY4a0EifQ.TKGQeDzlp7-mWS5bEAf36_aejZAkx03osY_jX6Bhxodynu5f5CDK0XYjopFYFqqNoxrMyMSyZQGxfekIbW3bXw2yrVlfzCZDISD1BOd9UUQ-1h7W8lkugT_VE5VRdTwCjBa7Aw_8ABM7_NcT2YCzxAbFhWEkLbWKRsbrhCrDNb7GTjktvij_2rzJut-nhB9tiSoGB_UuR4Ztih3CVbCK7rgz4fPRbkAYUViOOVRu23Wviut96Pf2q9FpF34qdmQpKGJ4upGVeW50WyVQV1uK2NvcAul2R_E2NmSV0hFazMuNupVOVZo5S9xdtCYJNjNQirkxrFZTrzhApYUcgmdoSA"
  // return tempOktaToken;
};

export const loginAuth0WithRedirect = async (options) => {
  if (!loginWithRedirectGlobal) {
    console.log("Auth0 'loginWithRedirect' function not set.");
    return;
  }
  try {
    await loginWithRedirectGlobal(options);
  } catch (error) {
    console.log("Error during Auth0 login redirect:", error);
  }
};
